import "./Organize.css";

import Imgs from "./homepage_images/home-images/screen.png";

import Inventory2Icon from "@mui/icons-material/Inventory2";
import CategoryIcon from "@mui/icons-material/Category";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import InfoIcon from "@mui/icons-material/Info";

export default function Organize() {
  return (
    <section className="sectionOrganize">
      <div className="OrganizeCont">
        {/* =====================================================
            LEFT — PRODUCT VISUAL
        ====================================================== */}

        <figure className="OrganizeLeft">
          <div className="OrganizeVisualHeader">
            <span className="OrganizeLiveDot"></span>
            <span>LIVE BUSINESS OVERVIEW</span>
          </div>

          <div className="OrganizeVisual">
            <div className="OrganizeVisualGlow"></div>

            <div className="OrganizeScreen">
              <img src={Imgs} alt="Universe Inventory dashboard" />
            </div>

            <div className="OrganizeFloatingCard OrganizeFloatingCardTop">
              <span className="OrganizeFloatingIcon">
                <AnalyticsIcon />
              </span>

              <div>
                <strong>Live Intelligence</strong>
                <span>Business data in context</span>
              </div>
            </div>

            <div className="OrganizeFloatingCard OrganizeFloatingCardBottom">
              <span className="OrganizeFloatingCheck">✓</span>

              <div>
                <strong>Everything connected</strong>
                <span>Inventory · Sales · Operations</span>
              </div>
            </div>
          </div>

          <figcaption>
            <span>UNIVERSE INVENTORY</span>
            <span>01 / 03</span>
          </figcaption>
        </figure>

        {/* =====================================================
            RIGHT — CONTENT
        ====================================================== */}

        <div className="OrganizeRight">
          <div className="OrganizeHeading">
            <span className="OrganizeEyebrow fx-ac space1">
              <InfoIcon />
              <span>ADVANCED INVENTORY MANAGEMENT</span>
            </span>

            <h3>
              Real-Time
              <strong> Inventory Intelligence </strong>
              for Smarter Decisions
            </h3>

            <p className="OrganizeIntro">
              Know what is happening across your business without having to be
              everywhere at once.
            </p>
          </div>

          {/* =====================================================
              FEATURES
          ====================================================== */}

          <div className="OrganizeFeatures">
            <article className="OrganizeFeature">
              <div className="OrganizeFeatureIcon">
                <Inventory2Icon />
              </div>

              <div className="OrganizeFeatureContent">
                <div className="OrganizeFeatureTop">
                  <span>01</span>

                  <h4>Stay Connected with your Business</h4>
                </div>

                <p>
                  Whether you are at the shop, in another branch, meeting a
                  customer, travelling, or simply away from the business,
                  <strong> Universe Inventory </strong>
                  helps keep you
                  <strong> connected to the operation.</strong>
                  You remain informed, your team remains connected, and your
                  business keeps moving.
                </p>
              </div>
            </article>

            <article className="OrganizeFeature">
              <div className="OrganizeFeatureIcon">
                <CategoryIcon />
              </div>

              <div className="OrganizeFeatureContent">
                <div className="OrganizeFeatureTop">
                  <span>02</span>

                  <h4>Know Your Business in Control.</h4>
                </div>

                <p>
                  Because managing a business is more than knowing what you have
                  in stock. It is knowing what is happening, when it happens,
                  and having the ability to
                  <strong> stay in control wherever business takes you.</strong>
                </p>
              </div>
            </article>
          </div>

          {/* =====================================================
              CTA
          ====================================================== */}

          <div className="OrganizeCTA">
            <button className="OrganizeButton">
              <span>Register in few steps</span>

              <span className="OrganizeButtonArrow">↗</span>
            </button>

            <span className="OrganizeCTAHint">
              Get your operation organized from day one.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
